/**
 * Not Found Page
 *
 * A directly-navigable "not found" route (`/not-found`), used when app logic
 * determines a resource is missing/inaccessible (e.g. an invalid tenant) and
 * needs to redirect the user, for example via `<Redirect href="/not-found" />`.
 *
 * For URLs that don't match any route at all, see `+not-found.tsx`, which is
 * the catch-all Expo Router renders automatically.
 */

import { NotFoundContent } from "@src/components/NotFoundContent";

export default function NotFoundScreen() {
  return <NotFoundContent />;
}
